import { IId, IName } from '@interfaces/common/common';
import { INetconfEventsDTO, INetconfEventsExportDTO } from '@interfaces/vesData/dto/netconfEventsDTO';
import { INetconfEvent, INetconfEventPreview, INetconfEventsResponse } from '@interfaces/vesData/netconfEvents';

import { client } from './client';
import { URL } from './urls';

const {
	netconfEvents,
} = URL;

export const getNetconfEvents = (params: INetconfEventsDTO): Promise<INetconfEventsResponse> => {
	return client.get(netconfEvents, { params });
};

export const getNetconfEventById = ({ id }: IId): Promise<INetconfEvent> => {
	return client.get(`${netconfEvents}/${id}`);
};

export const getNetconfEventPreview = ({ id }: IId): Promise<INetconfEventPreview> => {
	return client.get(`${netconfEvents}/${id}/preview`);
};

export const getNetconfEventTypes = (): Promise<IName<string>[]> => {
	return client.get(`${netconfEvents}/event-types`);
};

export const getNetconfMiddlewares = (): Promise<IName<string>[]> => {
	return client.get(`${netconfEvents}/middlewares`);
};

export const getNetconfNetworkElements = (): Promise<IName<string>[]> => {
	return client.get(`${netconfEvents}/network-elements`);
};

export const exportNetconfNetworkElements = (dto: INetconfEventsExportDTO): Promise<void> => {
	return client.post(`${netconfEvents}/export`, dto);
};
